import { gql } from '@apollo/client';

export const GET_ALL_FLYERS_FACETS = gql`
query getAllFlyers($input: GetAllFlyersInput!) {
  getAllFlyers(input: $input) {
    facets {
      categories {
        key
        count
      }
      gradesOrAges {
        key
        count
      }
    }
    pagination {
      total
    }
  }
}
`
